module.exports = __webpack_public_path__ + "fbbd399f0984a097e24188bdb502bbe2.jpg";